import React, { useContext } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  useTheme,
  useMediaQuery,
  alpha
} from '@mui/material';
import {
  ArrowBack as BackIcon,
  Settings as SettingsIcon,
  History as HistoryIcon,
  LightMode as LightModeIcon,
  DarkMode as DarkModeIcon,
  Psychology as PsychologyIcon
} from '@mui/icons-material';
import { ThemeContext } from '../../../App';

interface ParkingTestHeaderProps {
  projectName: string;
  onBack: () => void;
  onOpenSettings: () => void;
  onOpenHistory: () => void;
}

export const ParkingTestHeader: React.FC<ParkingTestHeaderProps> = ({
  projectName,
  onBack,
  onOpenSettings,
  onOpenHistory,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const { toggleTheme } = useContext(ThemeContext);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <AppBar
      position="sticky"
      className="glass-medium"
      sx={{
        bgcolor: isDark ? alpha(theme.palette.background.paper, 0.8) : alpha(theme.palette.background.paper, 0.95),
        borderBottom: '1px solid',
        borderColor: 'divider',
        backdropFilter: 'blur(10px)'
      }}
      elevation={0}
    >
      <Toolbar>
        <IconButton
          edge="start"
          onClick={onBack}
          className="hover-lift"
          sx={{ mr: 2 }}
        >
          <BackIcon />
        </IconButton>

        <PsychologyIcon sx={{ mr: 2, color: 'primary.main' }} />

        <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 700 }}>
          주차면 학습 테스트 - {projectName}
        </Typography>

        {isMobile && (
          <Box sx={{ display: 'flex', gap: 1 }}>
            <IconButton
              onClick={onOpenSettings}
              className="hover-lift"
            >
              <SettingsIcon />
            </IconButton>
            <IconButton
              onClick={onOpenHistory}
              className="hover-lift"
            >
              <HistoryIcon />
            </IconButton>
          </Box>
        )}

        <IconButton
          onClick={toggleTheme}
          className="hover-lift"
          sx={{ ml: 1 }}
        >
          {isDark ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};
